import { COLORS, SPACINGS } from './theme'

import styled from 'styled-components'

export interface StatusProps {
  variant: 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'quinary'
}

const Dot = styled.div<StatusProps>`
  margin-top: 0.125em;
  border-radius: 50%;
  width: ${(props) => (props.variant !== 'primary' ? SPACINGS[1] : '6px')};
  height: ${(props) => (props.variant !== 'primary' ? SPACINGS[1] : '6px')};
  background: ${(props) => {
    switch (props.variant) {
      case 'primary':
        return `repeating-linear-gradient(
          45deg,
          ${COLORS.primary.white},
          ${COLORS.primary.white} 1px,
          ${COLORS.orange.light.primary} 1px,
          ${COLORS.orange.light.primary} 2px
        )`
      case 'secondary':
        return COLORS.orange.light.primary
      case 'tertiary':
        return COLORS.citrus.mid.primary
      case 'quaternary':
        return COLORS.green.light.primary
      case 'quinary':
        return COLORS.red.mid.primary
    }
  }};
  ${(props) => {
    if (props.variant === 'primary') {
      return `border: 1px solid ${COLORS.orange.light.primary};`
    } else {
      return ''
    }
  }}
`

export function Status(props: StatusProps) {
  return <Dot {...props} />
}
